/**
 * A functional React component that displays alert notifications to users.
 *
 * This component integrates with the Material-UI Alert component and custom styling
 * to render contextual alert messages. It retrieves alert text and severity type from
 * the useAlert hook, and only renders when both text and type are available.
 *
 * @module components/common/AlertPopup
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';
import useAlert from './UseAlert';
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from '@material-ui/core/styles';
import AlertPopupStyle from "./AlertPopup.js";

/**
 * AlertPopup is a functional React component that renders an alert message.
 * It uses external styles and severity type from custom hooks.
 * The component checks for the presence of text and type from `useAlert`.
 * If both are provided, it displays an alert with the given severity and message.
 * Otherwise, it renders an empty fragment.
 */
const AlertPopup = () => {
    const useStyles = makeStyles((theme) => AlertPopupStyle(theme));
    const classes = useStyles();
    const { text, type } = useAlert();

    if (text && type) {
        return (
            <Alert
                className={classes.alert}
                severity={type}
            >
                {text}
            </Alert>
        );
    } else {
        return <></>;
    }
};

export default AlertPopup;